import React from "react";

// FIXME this control is not used and may not play well (in terms of appearance) with other components of query-builder
const BootstrapNotToggle = ({ className, handleOnChange, title, checked }) => (
  <div className={`form-check-inline ${className}`}>
    <input
      id="notToggle"
      className="form-check-input"
      type="checkbox"
      onChange={(e) => handleOnChange(e.target.checked)}
      checked={!!checked}
    />
    <label title={title} htmlFor="notToggle">
      Not
    </label>
  </div>
);

BootstrapNotToggle.displayName = "BootstrapNotToggle";

export default BootstrapNotToggle;
